import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types/Api";
import { Notification } from "@lib/types/Notification";

export const apiGetNotifications = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/notification` });
  return API.get<PaginationType<Notification>>(url);
};

export const apiMarkNotificationAsRead = async (id: string) => {
  const url = `/notification/resolve/${id}`;
  return API.patch(url);
};

export const apiMarkAllNotificationsAsRead = async (ids: string[]) => {
  const url = `/notification/resolve/bulk`;
  return API.post(url, { ids });
};
